import React, { useEffect, useState } from "react";
import { AppShell } from "@/components/AppShell";
import { StatusBadge } from "@/components/StatusBadge";
import { api } from "@/lib/api";
import { BarChart3 } from "lucide-react";

const MODULES = ["leads", "tickets", "invoices", "purchase_orders", "campaigns", "design_items"];

export default function Reports() {
  const [stats, setStats] = useState([]);
  const [pipeline, setPipeline] = useState({});

  useEffect(() => {
    Promise.all(MODULES.map((m) => api.get(`/modules/${m}/stats`).then((r) => r.data).catch(() => null)))
      .then((res) => setStats(res.filter(Boolean)));
    api.get("/dashboard/management").then((r) => setPipeline(r.data.projects_by_status || {})).catch(() => {});
  }, []);

  return (
    <AppShell title="Reports & Analytics">
      <p className="text-sm text-neutral-500 -mt-3 mb-6">Live operating metrics across the departments you can access.</p>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
        {stats.map((s) => (
          <div key={s.module} data-testid={`report-kpi-${s.module}`} className="bg-white rounded-lg border border-[#D7C6A9] p-4">
            <div className="text-xs text-neutral-500 uppercase tracking-wider">{s.label}</div>
            <div className="mono text-3xl font-extrabold text-neutral-900 mt-1.5">{s.total}</div>
          </div>
        ))}
        {stats.length === 0 && <div className="col-span-full text-sm text-neutral-400 py-8 text-center bg-white rounded-lg border border-[#D7C6A9]">No accessible department metrics.</div>}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg border border-[#D7C6A9] p-5">
          <h2 className="font-heading text-base font-semibold text-neutral-900 mb-4 flex items-center gap-2"><BarChart3 size={16} className="text-[#F5691C]" /> Project Pipeline</h2>
          {Object.keys(pipeline).length === 0 ? <p className="text-sm text-neutral-400">No projects.</p> : (
            <div className="space-y-2.5">
              {Object.entries(pipeline).map(([s, c]) => (
                <div key={s} className="flex items-center gap-3"><div className="w-40"><StatusBadge status={s} /></div><div className="flex-1 h-2 rounded-full bg-[#EEE9DE] overflow-hidden"><div className="h-full bg-[#F5691C]" style={{ width: `${Math.min(100, c * 25)}%` }} /></div><span className="mono text-sm w-6 text-right">{c}</span></div>
              ))}
            </div>
          )}
        </div>
        {stats.map((s) => (
          <div key={s.module} className="bg-white rounded-lg border border-[#D7C6A9] p-5">
            <h2 className="font-heading text-base font-semibold text-neutral-900 mb-4">{s.label} by status</h2>
            <div className="space-y-2.5">
              {s.statuses.map((st) => (
                <div key={st} className="flex items-center justify-between text-sm"><span className="text-neutral-600">{st.replaceAll("_", " ")}</span><span className="mono text-neutral-900">{s.by_status[st] || 0}</span></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </AppShell>
  );
}
